import { DecimalPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, ModalController, Platform } from "ionic-angular";
import moment from "moment";
import { Observable } from "rxjs";
import { ISubscription } from "rxjs/Subscription";
import SortOptions from "../../../../models/content-wrapper/sort-options";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { ResourceManagementService } from "../../../../providers/resource-management/resource-management.service";
import { convertToVoiceTextarea } from "../../../../utils/convert-to-voice-textarea";
import { IntercardDataService } from "../intercard-data/intercard-data.service";

const dateTimeFormat = "MM/DD/YYYY HH:mm";
const dateFormat = "MM/DD/YYYY";
/**
 * Generated class for the NarrativeListCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "expandable-list-card",
  templateUrl: "expandable-list-card.html",
})
export class ExpandableListCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;

  id: string;
  label: string;
  componentId: string;
  access: string;
  tooltip: object;
  colHeaders: string[];
  dataHeaders: string[];
  deltaFields: string[];
  dataRows: any[] = [];
  rawData: any[] = [];
  prevRow: {};
  declinable: boolean;
  editable: boolean = false;
  dataPages: Array<object[]> = [];
  pageSize: number = 5;
  currentPage: number = 0;
  newConfig;
  truncateLength = 300;
  cardDepObs: Observable<any> = null;
  cardDepObsSubscription: ISubscription;
  allowExternalData: boolean = false;
  addNewData: boolean = true;
  deleteNewData: boolean = true;
  resourceData = [];
  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public translatePipe: TranslateService,
    private alertCtrl: AlertController,
    public plt: Platform,
    public intercard: IntercardDataService,
    public resourceManagementService: ResourceManagementService
  ) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.access = this.config.access;
    this.tooltip = this.config.tooltip;
    this.colHeaders = this.config.data.listHeaders;
    this.dataHeaders = this.config.data.dataHeaders;
    if (this.config.hospiceAideCarePlanToggle) {
      this.dataHeaders = this.config.data.dataHeadersToggle;
    }
    this.deltaFields = this.config.data.deltaFields || [];
    this.declinable = this.config.declinable;
    //This new config is checking for duplicates in the dropdown
    this.newConfig = JSON.parse(JSON.stringify(this.config));
    if (this.config.addData == false) {
      this.addNewData = this.config.addData;
    }

    if (this.config.deleteData == false) {
      this.deleteNewData = this.config.deleteData;
    }

    if (this.config.editable) {
      this.editable = this.config.editable;
    }

    if (this.config.allowExternalData) {
      this.allowExternalData = this.config.allowExternalData;
    }

    if (this.allowExternalData) {
      this.cardDepObs = this.intercard.register(this.label);
      this.cardDepObsSubscription = this.cardDepObs.subscribe((data) => {
        // this.cardDepObs.subscribe(data => {
        // console.log( "Received emitted data from other card!", data );
        if (data === undefined) {
          return;
        } else if (data["declined"] === true || data["noChanges"] === true) {
          // console.log(data);

          let accept = () => {
            // console.log("accepting");
            let obj = {};
            if (data["declined"]) {
              obj["acceptedDecline"] = true;
            }
            if (data["noChanges"]) {
              obj["acceptedNoChanges"] = true;
            }
            this.intercard.emitData("declines", obj);
          };

          let reject = () => {
            // console.log( "List modal REJECTED!" );

            let obj = {};
            if (data["declined"]) {
              obj["rejectedDeclined"] = true;
            }
            if (data["noChanges"]) {
              obj["rejectedNoChanges"] = true;
            }
            this.intercard.emitData("declines", obj);
          };

          if (this.config.id == "CL010.264") {
            this.presentListForm(
              { category: "patientDeclinedHospAideVisit" },
              accept,
              reject
            );
          } else {
            this.presentListForm(
              { category: "patientDeclinedAssessment" },
              accept,
              reject
            );
          }
          return;
        }

        let newData = {};
        for (let header of this.colHeaders) {
          if (data[header]) {
            newData[header] = data[header];
          }
        }

        this.addData(newData);
      });
    }

    if (this.config.hospiceAideCarePlanToggle) {
      this.config.inputs = JSON.parse(JSON.stringify(this.config.inputsToggle));
      this.newConfig.inputs = JSON.parse(
        JSON.stringify(this.config.inputsToggle)
      );
      this.resourceData = this.getResourceManagementData();
    }
  }

  @Input() set data(incomingData: any) {
    // console.log("Form card Data: ", this.data);
    // console.log("Form card Incoming data: ", incomingData);
    if (incomingData) {
      let cardData = incomingData;

      // Call some service to load rows and prevRow
      this.dataRows = [];
      if (cardData.data) {
        this.rawData = cardData.data;
        for (let data of cardData.data) {
          let info = { id: data.id };
          let values = this.parseDataRow(data);
          info["values"] = values;
          this.dataRows.push(info);
        }
      }

      this.updateDataPages();
    }
  }

  presentListForm(data?: object, accept?: Function, reject?: Function): void {
    this.config.dataRows = this.dataRows;
    let config = { config: this.config };
    if (data !== undefined) {
      config["data"] = data;
    }

    // Convert to voiceTextarea if needed
    config = convertToVoiceTextarea(config);

    let listModal = this.modalCtrl.create("InputModalPage", config, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined && data !== null) {
        this.addData(data);
        if (accept) {
          accept();
        }
      } else if (reject) {
        reject();
      }
    });
    listModal.present();
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      if (typeof data[key] == "object" && data[key] !== null) {
        let innerObj = data[key];
        for (let innerKey of Object.keys(innerObj)) {
          if (key == "provideSupport") {
            let newKey = key;
            flatData[newKey] = innerObj[innerKey];
          } else if (key == "frequency") {
            // console.log( "Detected frquency input, parsing to string: ", innerObj );
            let finalValue = "";
            if (innerObj.numerator) {
              finalValue +=
                innerObj.numerator +
                this.translatePipe.instant(" time(s) per ");
            }

            if (innerObj.denominator) {
              finalValue += innerObj.denominator + " ";
            }

            if (innerObj.timeUnit) {
              finalValue += this.translatePipe.instant(innerObj.timeUnit);
            }

            flatData[key] = finalValue;
          } else {
            let newKey =
              key + innerKey.replace(/\b\w/g, (l) => l.toUpperCase());
            flatData[newKey] = innerObj[innerKey];
          }
        }
      } else {
        if (data[key] !== null) {
          flatData[key] = data[key];
        }
      }
    }
    // console.log( "FLATTENED IT: ", flatData );
    return flatData;
  }

  parseDataRow(data: object) {
    // console.log( "Col headers: ", this.colHeaders );
    // console.log( "Data headers: ", this.dataHeaders );
    let values = {};
    let flatData = this.flattenIncomingData(data);
    for (let header of this.colHeaders) {
      // console.log( "Checking col header: ", header );
      let val = "-";
      if (flatData[header]) {
        if (header === "date") {
          flatData[header] = moment(flatData[header]).format(dateTimeFormat);
        }
        val = flatData[header];
      }
      // console.log( "Produced val: ", val );
      values[header] = val;
    }
    for (let header of this.dataHeaders) {
      // console.log( "Checking data header: ", header );
      let val = "-";
      let tempHeader = header;
      if (header != "date" && header.toLowerCase().includes("date")) {
        tempHeader += "Date";
      }
      if (flatData[tempHeader]) {
        if (header === "date" || header.toLowerCase().includes("date")) {
          flatData[tempHeader] = moment(flatData[tempHeader]).format(
            dateFormat
          );
        }
        val = flatData[tempHeader];
      }
      // console.log( "Produced val: ", val );
      values[header] = val;
    }
    return values;
  }

  addData(data: any): void {
    //console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .storeRecord(this.assessmentId, this.sectionId, this.id, data)
          .subscribe((returnData) => {
            //console.log( "Data returned from submission:", returnData );
            if (!returnData) {
              return;
            }

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            // console.log("Pushing new val.", newData);
            this.rawData.unshift(returnData);
            this.dataRows.unshift(newData);
            this.updateDataPages();
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  editRow(row: object): void {
    this.config = JSON.parse(JSON.stringify(this.newConfig));
    this.config.dataRows = this.dataRows;
    let modalConfig = { config: this.config };
    let values = this.rawData.filter((record) => record.id == row["id"])[0];
    if (values !== null || values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData = {};
      for (let key of inputKeys) {
        if (values[key]) {
          if (key === "issueType") {
            values[key] = this.translatePipe.instant(values[key]);
          } else if (key === "speakWith") {
            if (this.config.hospiceAideCarePlanToggle) {
              modalConfig.config.inputs[key].options = this.resourceData;
            }
          }
          editData[key] = values[key];
        } else {
          if (key === "speakWith") {
            if (this.config.hospiceAideCarePlanToggle) {
              modalConfig.config.inputs[key].options = this.resourceData;
            }
          }
          editData[key] = null;
        }
      }
      modalConfig["data"] = editData;
    }

    // Convert to voiceTextarea if needed
    modalConfig = convertToVoiceTextarea(modalConfig);

    // console.log( "Launching edit with modal config: ", modalConfig );
    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined) {
        this.editData(row, row["id"], data);
      }
    });
    listModal.present();
  }

  public getResourceManagementData() {
    let array = [];
    this.resourceManagementService
      .getCompanyResourceProvidersAndNonProviders(
        0,
        10000,
        "",
        new SortOptions("last_name", "asc")
      )
      .subscribe((data) => {
        for (let dt of data) {
          for (let content of dt.content) {
            let object = content.firstName + " " + content.lastName;
            array.push(object);
          }
        }
      });
    return array;
  }

  editData(oldRow: object, rowId: string, data: any): void {
    // console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .editRecord(this.assessmentId, this.sectionId, this.id, rowId, data)
          .subscribe((returnData) => {
            // console.log( "Data returned from edit:", returnData );

            if (!returnData) {
              return;
            }

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            let rawData = this.rawData;
            for (let index in rawData) {
              if (rawData[index]["id"] === returnData.id) {
                rawData[index] = returnData;
                break;
              }
            }

            this.dataRows.splice(this.dataRows.indexOf(oldRow), 1, newData);
            this.updateDataPages();
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  deleteRow(id: string) {
    let alert = this.alertCtrl.create({
      title: this.translatePipe.instant("confirmDeleteRecord"),
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Proceed",
          handler: () => {
            this.dataService
              .deleteRecord(this.assessmentId, this.sectionId, this.id, id)
              .subscribe(() => {
                this.rawData = this.rawData.filter((row) => row.id !== id);
                this.dataRows = this.dataRows.filter((row) => row.id !== id);
                this.updateDataPages();
                if (this.componentId == "dependentOnAdls") {
                  this.intercard.emitData("notes", { adls: true });
                }
              });
          },
        },
      ],
    });
    alert.present();
  }

  updateDataPages() {
    this.dataPages = [];

    let dataRows = this.dataRows;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (this.currentPage > dataRows.length % pageSize) {
      this.prevPage();
    }
    // console.log( "Produced pages: ", this.dataPages );
  }

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  setPage(page) {
    if (
      page >= 0 &&
      page <= this.dataPages.length &&
      page !== this.currentPage
    ) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  lastPage() {
    if (this.currentPage !== this.dataPages.length - 1) {
      this.currentPage = this.dataPages.length - 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/expandable-list-card/expandable-list-card.ts